const BellSvg = ({
  height = 30,
  width = 30,
  viewBox = '0 0 30 30',
  stroke = 'white',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  stroke?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M18.75 21.25V22.5C18.75 24.5711 17.0711 26.25 15 26.25C12.9289 26.25 11.25 24.5711 11.25 22.5V21.25M18.75 21.25H11.25M18.75 21.25H23.2381C23.7163 21.25 23.9565 21.25 24.1501 21.1847C24.5199 21.0599 24.8093 20.7696 24.9341 20.3997C24.9997 20.2053 24.9997 19.9644 24.9997 19.4824C24.9997 19.2715 24.9994 19.1661 24.9829 19.0656C24.9517 18.8756 24.878 18.6954 24.7657 18.539C24.7064 18.4564 24.6309 18.381 24.4823 18.2323L23.9954 17.7454C23.8383 17.5883 23.75 17.3752 23.75 17.153V12.5C23.75 7.6675 19.8325 3.74999 15 3.75C10.1675 3.75001 6.25 7.66752 6.25 12.5V17.153C6.25 17.3752 6.16155 17.5883 6.00446 17.7454L5.51758 18.2322C5.36845 18.3814 5.2938 18.4563 5.23438 18.5391C5.12207 18.6955 5.04768 18.8755 5.0165 19.0656C5 19.1661 5 19.2715 5 19.4824C5 19.9644 5 20.2053 5.06557 20.3997C5.19031 20.7695 5.481 21.0599 5.85083 21.1847C6.04445 21.25 6.28377 21.25 6.76194 21.25H11.25"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default BellSvg;
